import request from '@/lib/util/request';
import { CreateCustomizedParams } from '@/lib/type/customized.type';

// 创建询盘接口
export const requestCreateCustomized = (data: CreateCustomizedParams) =>
  request({
    endpoint: '/api/tiny-shop/v1/member/opinion/create',
    method: 'POST',
    body: data,
  });
